<div class="container-visualizacao">
    <div class="row container-options">
        <div class="col-12">
            <button type="button" class="btn btn-primary mr-2" (click)="insert()"><i class="fas fa-plus" aria-hidden="true"></i> Novo</button>                 

            <!-- Opções -->
            <div class="btn-group" *ngIf="options?.hasAnyOption()">
                <button type="button" class="btn btn-light dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <span class="d-none d-sm-inline-block">Opções</span>
                </button>
                <div class="dropdown-menu">                    
                    <!-- Import ERP -->
                    <a class="dropdown-item" *ngIf="options?.canImportErp" (click)="openIntegracaoErpImportModal()">
                        <i class="fas fa-download"></i> Importar do ERP
                    </a>                
                </div>
            </div>  
            
            <span class="float-right">
                <div class="btn-group">
                    <button type="button" class="btn btn-light" (click)="search()">
                        <i class="fas fa-search" aria-hidden="true"></i>
                    </button>
                    <button type="button" class="btn btn-light" (click)="clearFilter()">
                        <i class="fas fa-eraser" aria-hidden="true"></i>
                    </button>
                    <button type="button" class="btn" [class.btn-light]="!filterCollapse.isFilterDirty" [class.btn-danger]="filterCollapse.isFilterDirty"
                        (click)="filterCollapse.toggleCollapse()">
                        <i class="fas fa-filter" aria-hidden="true"></i>
                        <i [class]="filterCollapse.collapseIcon" aria-hidden="true"></i>
                    </button>
                </div>                
            </span>            
        </div>
    </div>
    <div class="row container-table" #containerTable>
        <div class="col-12">
            <div class="row container-filter">
                <div class="col-12">
                    <sgt-regiao-filter-collapse
                        [filter]="filter"
                        #filterCollapse>
                    </sgt-regiao-filter-collapse>
                </div>
            </div> 

            <div class="row">
                <div class="col-12">
                    <table class="table table-striped table-hover datatables" id="tableRegioes">
                        <thead>
                            <tr>
                                <th class="col-options"></th>
                                <th class="col-codigo text-right">Código</th>
                                <th class="col-codigo-integracao-erp text-right">Código ERP</th>
                                <th class="col-nome">Nome</th>
                                <th class="col-situacao text-center">Situação</th>
                            </tr>
                        </thead>
                    </table>                     
                </div>
            </div>
        </div>
    </div>    
</div>

<!-- Container para criar dinamicamente o badge da situação -->
<ng-template #badgeSituacaoContainer></ng-template>

<!-- Modal para importar as regiões do ERP -->
<sgt-regiao-integracao-erp-import-modal
    #integracaoErpImportModal>
</sgt-regiao-integracao-erp-import-modal>